import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import "../../common/planTheme.css";
import "./Form.css";
import { TextField } from "@material-ui/core";
import axios from "axios";
import Swal from "sweetalert2";
import { DecryptED } from "../../DecryptJS/Decrypt";

const Form = () => {
  const history = useHistory();
  let { sid, userid } = useParams();
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [lessonName, setLessonName] = useState("");
  const [lessonObjective, setLessonObjective] = useState("");
  const [learningOutcome, setLearningOutcome] = useState("");
  const [pedagogicalPractices, setPedagogicalPractices] = useState("");
  const [audioVisualAdis, setAudioVisualAdis] = useState("");
  const [teacherPreparation, setTeacherPreparation] = useState("");
  const [studentPreparation, setStudentPreparation] = useState("");
  const [additionalExtended, setAdditionalExtended] = useState("");
  const [interdisciplinaryLinkage, setInterdisciplinaryLinkage] = useState("");
  const [infusion, setInfusion] = useState("");
  const [artIntegration, setArtIntegration] = useState("");
  const [storyBased, setStoryBased] = useState("");
  const [artificialIntelligence, setArtificialIntelligence] = useState("");
  const [fln, setFln] = useState("");
  const [remedialPlan, setRemedialPlan] = useState("");
  const [cwsnPlan, setCwsnPlan] = useState("");
  const [assignment, setAssignment] = useState("");
  const [referenceUsed, setReferenceUsed] = useState("");
  const [currentAcadId, setCurrentAcadId] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [lessonDuration, setLessonDuration] = useState("");
  const [month, setMonth] = useState("");
  const [arr, setArr] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  const submitForm = async (e) => {
    e.preventDefault();
    if (lessonName && classId && month && subjectId && lessonDuration) {
      const data = {
        fun_name: "addLessonplanData",
        user_id: DecryptED(userid),
        sid: DecryptED(sid),
        acad_id: currentAcadId,
        month,
        subject_id: `${subjectId}`,
        classdiv_id: `${classId}`,
        Lessonname: lessonName,
        Lessonduration: `${lessonDuration}`,
        lesson_objective: lessonObjective,
        learning_outcome: learningOutcome,
        pedagogical_practices: pedagogicalPractices,
        audio_visual_adis: audioVisualAdis,
        teacher_preparation: teacherPreparation,
        student_preparation: studentPreparation,
        additional_extended_information: additionalExtended,
        interdisciplinary_linkage: interdisciplinaryLinkage,
        infusion_with_life_skills: infusion,
        art_integration: artIntegration,
        story_based: storyBased,
        artificial_intelligence: artificialIntelligence,
        fln: fln,
        remedial_plan: remedialPlan,
        cwsn_plan: cwsnPlan,
        assignment: assignment,
        reference_used: referenceUsed,
      };
      setSubmitting(true);
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        if (response.data && response.data.success !== false) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: `LessonPlan for ${lessonName} has been submitted successfully!`,
            showConfirmButton: false,
            timer: 1500,
          });
          history.push(`/lessonHome/${sid}/${userid}`);
        } else {
          Swal.fire("Error", (response.data && response.data.message) || "Could not submit the lesson plan", "error");
        }
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Could not submit the lesson plan. Please try again.", "error");
      } finally {
        setSubmitting(false);
      }
    } else {
      let missingFields = [];

      if (!lessonName) missingFields.push("Lesson Name");
      if (!classId) missingFields.push("Class");
      if (!month) missingFields.push("Month");
      if (!subjectId) missingFields.push("Subject");
      if (!lessonDuration) missingFields.push("Lesson Duration");

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Please fill the required fields: ${missingFields.join(", ")}`,
      });
    }
  };
  const selectClassIdHandler = async (e) => {
    const newClassId = e.target.value;
    setClassId(newClassId === "default" ? "" : newClassId);
    setSubjectId("");
    setSubjectList([]);
    if (newClassId === "default") return;
    try {
      const response = await axios.post(
        "https://topschool.prisms.in/rest/index.php/staff_list.json",
        {
          fun_name: "getAccessClassSubject",
          sid: DecryptED(sid),
          staff_id: DecryptED(userid),
          div_id: newClassId,
        }
      );
      setSubjectList((response.data && response.data.result) || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Could not load subjects for this class.", "error");
    }
  };
  useEffect(() => {
    const getAccessableClass = async () => {
      const data = {
        fun_name: "getAccessClass",
        sid: DecryptED(sid),
        staff_id: DecryptED(userid),
      };
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        setClassList((response.data && response.data.result) || []);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Could not load classes.", "error");
      } finally {
        setLoading(false);
      }
    };
    getAccessableClass();

    const getCurrentAcadId = async () => {
      const data = {
        fun_name: "currentAcadId",
        sid: DecryptED(sid),
      };
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        const acadResult = response.data && response.data.result && response.data.result[0];
        setCurrentAcadId((acadResult && acadResult.acadid) || "");
      } catch (error) {
        console.error(error);
      }
    };
    getCurrentAcadId();
  }, [sid, userid]);

  // Lesson Duration change 1 to 99.
  useEffect(() => {
    let arr = [];
    for (let i = 1; i <= 99; i++) {
      arr.push(i);
    }
    setArr(arr);
  }, []);
  if (loading) {
    return (
      <div className="lp-scope lessonform-page">
        <p className="lp-page-title" style={{ textAlign: "center" }}>Add Lesson Plan</p>
        <p style={{ textAlign: "center", padding: "20px", color: "#1565c0" }}>
          Loading…
        </p>
      </div>
    );
  }

  return (
    <div className="lp-scope lessonform-page">
      <p className="lp-page-title" style={{ textAlign: "center" }}>Add Lesson Plan</p>
      <form className="form lp-card" onSubmit={submitForm}>
        <div className="user-details">
          <p className="lp-section-title">Lesson Details</p>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="classSelect">
                Class<span className="lp-required">*</span>
              </label>
              <select
                className="lp-select"
                id="classSelect"
                value={classId || "default"}
                onChange={selectClassIdHandler}
              >
                <option value="default">Select Class</option>
                {classList &&
                  classList.map((data, idx) => {
                    return (
                      <option key={idx} value={data.id}>
                        {data.div_name}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="month">
                Month<span className="lp-required">*</span>
              </label>
              <input
                className="lp-input"
                onChange={(e) => setMonth(e.target.value)}
                name="month"
                id="month"
                type="month"
                placeholder=""
              />
            </div>
          </div>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="subjectSelect">
                Subject<span className="lp-required">*</span>
              </label>
              <select
                className="lp-select"
                id="subjectSelect"
                value={subjectId || "default"}
                onChange={(e) => setSubjectId(e.target.value === "default" ? "" : e.target.value)}
                disabled={!classId}
              >
                <option value="default">Select Subject</option>
                {subjectList &&
                  subjectList.map((data, idx) => {
                    return (
                      <option key={idx} value={data.id}>
                        {data.subject}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="lessonName">
                Lesson Name<span className="lp-required">*</span>
              </label>
              <input
                className="lp-input"
                value={lessonName}
                onChange={(e) => setLessonName(e.target.value)}
                id="lessonName"
                type="text"
                placeholder=""
              />
            </div>
          </div>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="lessonDuration">
                Lesson Duration<span className="lp-required">*</span>
              </label>
              <select
                className="lp-select"
                name="lessonDuration"
                id="lessonDuration"
                value={lessonDuration || "default"}
                onChange={(e) => setLessonDuration(e.target.value === "default" ? "" : e.target.value)}
              >
                <option value="default">Select Duration</option>
                {arr &&
                  arr.map((item, idx) => {
                    return (
                      <option key={idx} value={item}>
                        {item}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
        </div>
        <p className="lp-section-title" style={{ marginTop: "24px" }}>Lesson Content</p>
        <div className="mid-details">
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="lessonObjective"
              label="Lesson Objective"
              variant="outlined"
              size="small"
              value={lessonObjective}
              onChange={(e) => setLessonObjective(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="learningOutcome"
              label="Learning Outcome"
              variant="outlined"
              size="small"
              value={learningOutcome}
              onChange={(e) => setLearningOutcome(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="pedagogicalPractices"
              label="Pedagogical Practices"
              variant="outlined"
              size="small"
              value={pedagogicalPractices}
              onChange={(e) => setPedagogicalPractices(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="audioVisualAids"
              label="Audio/VisualAids"
              variant="outlined"
              size="small"
              value={audioVisualAdis}
              onChange={(e) => setAudioVisualAdis(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="teacherPreparation"
              label="Teacher Preparation"
              variant="outlined"
              size="small"
              value={teacherPreparation}
              onChange={(e) => setTeacherPreparation(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="studentPreparation"
              label="Student Preparation"
              variant="outlined"
              size="small"
              value={studentPreparation}
              onChange={(e) => setStudentPreparation(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="additionalExtended"
              label="Additional Extended Information"
              variant="outlined"
              size="small"
              value={additionalExtended}
              onChange={(e) => setAdditionalExtended(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="interdisciplinaryInfo"
              label="Interdisciplinary Information"
              variant="outlined"
              size="small"
              value={interdisciplinaryLinkage}
              onChange={(e) => setInterdisciplinaryLinkage(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="infusionLifeSkills"
              label="Infusion with Life Skills"
              variant="outlined"
              size="small"
              value={infusion}
              onChange={(e) => setInfusion(e.target.value)}
            />
          </div>
        </div>
        <div className="form-supplemental">
          <p className="lp-section-title">Supplemental Activities</p>
          <div>
            <TextField
              fullWidth
              id="artIntegration"
              label="Art-Integration"
              variant="outlined"
              size="small"
              value={artIntegration}
              onChange={(e) => setArtIntegration(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="storyBased"
              label="Story Based"
              variant="outlined"
              size="small"
              value={storyBased}
              onChange={(e) => setStoryBased(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="artificialIntelligence"
              label="Artificial Intelligence"
              variant="outlined"
              size="small"
              value={artificialIntelligence}
              onChange={(e) => setArtificialIntelligence(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="fln"
              label="FLN"
              size="small"
              value={fln}
              onChange={(e) => setFln(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="remedialPlanField"
              label="Remedial Plan"
              size="small"
              value={remedialPlan}
              onChange={(e) => setRemedialPlan(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="cwsnPlanField"
              label="CWSN Plan"
              size="small"
              value={cwsnPlan}
              onChange={(e) => setCwsnPlan(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="assignmentField"
              label="Assignment"
              size="small"
              value={assignment}
              onChange={(e) => setAssignment(e.target.value)}
            />
          </div>
          <div>
            <TextField
              fullWidth
              id="referenceUsedField"
              label="Reference Used"
              size="small"
              value={referenceUsed}
              onChange={(e) => setReferenceUsed(e.target.value)}
            />
          </div>
        </div>
        <div className="btn-div" style={{ marginTop: "24px" }}>
          <button type="submit" className="lp-btn lp-btn-primary" disabled={submitting}>
            {submitting ? "Submitting…" : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Form;
